import React from 'react';
import Navbar from "./components/Navbar";
import Routes from "./routes/Routes"

function App() {
  return (
    <div>
      <Navbar />
      <Routes />
    </div>
  );
}

export default App;
